export function SearchIcon({ className }: { className?: string }) {
  return (
    <div style={{ padding: "4px" }}>
      <svg
        className={className}
        width="16"
        height="16"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.95717 8.05628L11.5838 10.7296C11.7015 10.8568 11.765 11.0248 11.761 11.198C11.7569 11.3712 11.6855 11.5361 11.562 11.6576C11.4385 11.7791 11.2726 11.8478 11.0993 11.849C10.926 11.8503 10.7591 11.784 10.6338 11.6643L8.0085 8.99361C6.99553 9.75671 5.73043 10.1064 4.46935 9.97176C3.20828 9.83717 2.04547 9.22838 1.21638 8.26867C0.387291 7.30897 -0.0461247 6.07006 0.00389358 4.80281C0.0539119 3.53555 0.583626 2.33466 1.48578 1.44329C2.38793 0.551912 3.5951 0.0366678 4.86286 0.0018829C6.13063 -0.032902 7.36424 0.415371 8.31391 1.25594C9.26358 2.0965 9.85835 3.26654 9.97778 4.52914C10.0972 5.79174 9.73239 7.05255 8.95717 8.05628V8.05628ZM4.99984 8.66628C5.9723 8.66628 6.90493 8.27997 7.59256 7.59234C8.2802 6.9047 8.6665 5.97207 8.6665 4.99961C8.6665 4.02715 8.2802 3.09452 7.59256 2.40689C6.90493 1.71925 5.9723 1.33295 4.99984 1.33295C4.02738 1.33295 3.09475 1.71925 2.40711 2.40689C1.71948 3.09452 1.33317 4.02715 1.33317 4.99961C1.33317 5.97207 1.71948 6.9047 2.40711 7.59234C3.09475 8.27997 4.02738 8.66628 4.99984 8.66628V8.66628Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
